module.exports = __webpack_public_path__ + "img/punkte_1_bis_3.d07fb827.png";